import script from "./procurePayReview.vue?vue&type=script&setup=true&lang=js"
export * from "./procurePayReview.vue?vue&type=script&setup=true&lang=js"

import "./procurePayReview.vue?vue&type=style&index=0&id=dd676612&lang=less"

const __exports__ = script;

export default __exports__